import { FormGroups } from 'common/form';

export const getConversationSettingsGroups = (): FormGroups => {
  return {
    agentSettings: {
      label: 'Virtual agent settings',
      labelSx: {
        fontSize: '20px',
        fontWeight: 400,
        mb: '15px'
      },
      sx: {
        gap: '30px'
      }
    }
  };
};
